import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const OAuthPage = () => {
  const navigate = useNavigate();
  const { token, expirationTime } = useParams();
  const { login } = useAuth();

  useEffect(() => {
    if (token && expirationTime) {
      // localStorage에 토큰 저장 + AuthContext 상태 갱신
      login(token);
      navigate('/');
    }
  }, [token, expirationTime, navigate, login]);

  return (
    <div>
      <p>로그인 처리 중...</p>
    </div>
  );
};

export default OAuthPage;
